var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-block"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.matchedItem),function(m,index){return _c('el-breadcrumb-item',{key:index,class:m.name === _vm.curr_route ? 'route-active' : '',attrs:{"to":m.name ? { name: m.name, query: m.queryData } : ''}},[_vm._v(" "+_vm._s(m.meta.title)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }